function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }
connectedCallback() {
  if (this.swatches) {
    this.enableSwatches(this.swatches, this.image);
  }
  if (this.additional_images) {
    this.enableAdditionalImages();
  }
  if (this.quick_add) {
    this.enableQuickAdd();
  }
  if (this.size_options) {
    this.enableSizeOptions();
  }
}


  enableAdditionalImages() {
  const image_length = this.additional_images.length;
  const images = this.additional_images;
  const nav = this.additional_images_nav;
  const image_container = this.querySelector('.product-featured-image-link');
  if (!image_container || !image_length) return;

  // rAF-throttled hover/touch + cached layout
  let pending = false;
  let lastX = 0;
  let rect = null;

  const recalcRect = () => { rect = image_container.getBoundingClientRect(); };

  const schedule = (x) => {
    lastX = x;
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      if (!rect) recalcRect();
      const w = rect.width || 1;
      const l = Math.max(0, Math.min(lastX - rect.left, w));
      const sel = Math.floor((l / w) * image_length);
      const selimg = images[sel];
      if (!selimg) return;

      // swap active without looping entire list
      const prev = image_container.querySelector('.product-secondary-image.hover');
      if (prev && prev !== selimg) prev.classList.remove('hover');
      selimg.classList.add('hover');

      if (nav.length) {
        const prevNav = image_container.querySelector('.product-secondary-images-nav li.active');
        if (prevNav) prevNav.classList.remove('active');
        nav[sel]?.classList.add('active');
      }
    });
  };

  const onEnterMove = (e) => {
    const clientX = (e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX);
    schedule(clientX);
  };

  const onLeave = () => {
    images.forEach((img, i) => {
      img.classList.remove('hover');
      if (nav.length) nav[i].classList.remove('active');
    });
  };

  recalcRect();
  window.addEventListener('resize', () => { rect = null; }, { passive: true });

  image_container.addEventListener('mouseenter', onEnterMove, { passive: true });
  image_container.addEventListener('mousemove', onEnterMove, { passive: true });
  image_container.addEventListener('touchstart', onEnterMove, { passive: true });
  image_container.addEventListener('touchmove', onEnterMove, { passive: true });
  image_container.addEventListener('mouseleave', onLeave, { passive: true });

  // IMPORTANT: remove the old manual unveil loop (lazysizes handles this):
  // images.forEach(image => {
  //   window.addEventListener('load', () => lazySizes.loader.unveil(image));
  // });
}

    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch) => {
  // no preloading here
  swatch.addEventListener('mouseover', () => {
    swatch_list.forEach(el => el.classList.remove('active'));
    if (image) {
      image.setAttribute('srcset', swatch.dataset.srcset || org_srcset || '');
    }
    if (this.size_options) {
      this.current_options[this.color_index] = swatch.querySelector('span').innerText;
      this.updateMasterId();
    }
    swatch.classList.add('active');
  });
  swatch.addEventListener('click', function (evt) {
    window.location.href = swatch.dataset.href;
    evt.preventDefault();
  });
});

    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}


/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      this.onClick = (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      };
      // Add functionality to buttons
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('panel:close', this.onClick.bind(this));
      if (!this.cc.hasAttribute('initialized')) {
        this.cc.addEventListener('click', this.onClick.bind(this));
        this.cc.setAttribute('initialized', '');
      }

    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel.active');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer') || document.body.classList.contains('open-quick-view')) {
        this.close_quick_view();
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view() {
      let panel = document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {

  constructor() {
    this.container = document.getElementById('Cart-Drawer');

    if (!this.container) {
      return;
    }
    let _this = this,
      button = document.getElementById('cart-drawer-toggle'),
      quantities = this.container.querySelectorAll('.quantity input');


    // Add functionality to buttons
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      document.body.classList.add('open-cart');
      this.container.classList.add('active');
      this.container.focus();
      setTimeout(() => {
        if (this.container.querySelector('.product-recommendations--full')) {
          this.container.querySelector('.product-recommendations--full').classList.add('active');
        }
      });
      dispatchCustomEvent('cart-drawer:open');
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    this.container.addEventListener('change', (e) => {
  const q = e.target.closest('input.qty');
  if (q) this.debouncedOnChange(e);
});

    this.notesToggle();
    this.removeProductEvent();
    this.updateFreeShipping();
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
  updateFreeShipping() {
    const free_shipping = this.container.querySelector('.free-shipping');

    if (free_shipping) {
      let amount_text = free_shipping.querySelector('.free-shipping--text span');
      let total = parseInt(free_shipping.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(free_shipping.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;

      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
      }

      free_shipping.style.setProperty('--percentage', percentage);
    }
  }
  updateQuantity(line, quantity) {
    this.container.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    if (this.container.querySelector('.product-recommendations--full')) {
      this.container.querySelector('.product-recommendations--full').classList.remove('active');
    }
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.updateFreeShipping();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });

        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
      });
  }
  refresh() {
    if (this.container.querySelector('.product-recommendations--full')) {
      this.container.querySelector('.product-recommendations--full').classList.remove('active');
    }
    let sections = 'cart-drawer,cart-bubble';
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.updateFreeShipping();
      });
  }
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize', debounce(function () {
  document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
}, 150));

  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');
if (js_files.length > 0) {
  const head = document.head;
  js_files.forEach((js_file) => {
    if (!js_file.src) return;
    // skip if already on page
    if (document.querySelector('script[src="' + js_file.src + '"]')) return;
    const s = document.createElement('script');
    s.src = js_file.src;
    s.defer = true;
    s.crossOrigin = 'anonymous';
    head.appendChild(s);
  });
}


        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}
//buildBtnText: "הרכיבי קופסה משלך",
    //lockedNoteText: " ",
/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') new FooterMenuToggle();

  let cartDrawerInstance = null;
  function ensureCartDrawer() {
    if (!cartDrawerInstance && typeof CartDrawer !== 'undefined') {
      cartDrawerInstance = new CartDrawer();
    }
  }

  // Open button (delegated)
  document.addEventListener('click', (e) => {
    const t = e.target.closest('#cart-drawer-toggle,[data-cart-drawer-open]');
    if (t) ensureCartDrawer();
  }, { passive: true });

  // After any add-to-cart event fired in your code
  document.addEventListener('cart:item-added', ensureCartDrawer, { passive: true });

  // Idle fallback
  if ('requestIdleCallback' in window) {
    requestIdleCallback(ensureCartDrawer, { timeout: 6000 });
  } else {
    setTimeout(ensureCartDrawer, 6000);
  }
});

//CODIGO
document.querySelectorAll('.mobile-menu a, .mobile-menu__item a, .mobile-menu button').forEach(link => {
  const txt = link.textContent;

  // Detect parentheses
  if (/\(.*?\)/.test(txt)) {

    const updated = txt.replace(/\((.*?)\)/g, function(match, inner) {
      // parentheses included inside the <strong>
      return '<strong class="menu-bold">(' + inner + ')</strong>';
    });

    link.innerHTML = updated;
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(min-width: 1024px)').matches) return;
  const menuItems = document.querySelectorAll('.thb-full-menu .menu-item-has-children');
  menuItems.forEach(item => {
    item.addEventListener('mouseenter', () => document.body.classList.add('megamenu-open'));
    item.addEventListener('mouseleave', () => document.body.classList.remove('megamenu-open'));
  });
});


/* =========================================================
   BISCUITS v16.3 — Wizard modal + HARD single bundle + HARD single select
   ✅ Never allow 2 bundles in cart (reverts accidental adds on close)
   ✅ Keeps UPDATED one after Add/Update (keepNew)
   ✅ Forces single selection on chosen steps (even if Biscuits allows multi)
   ✅ Clamps kept bundle quantities to 1
   ✅ Adds "Choose your size" label above size select
========================================================= */
(() => {
  // Kill older versions if present
/*BORRAR COMENTARIO
  window.__bbBiscuitsWizardV11 = false;
  window.__bbBiscuitsWizardV12 = false;
  window.__bbBiscuitsWizardV13 = false;
  window.__bbBiscuitsWizardV14 = false;
  window.__bbBiscuitsWizardV141 = false;
  window.__bbBiscuitsWizardV15 = false;
  window.__bbBiscuitsWizardV16 = false;
  window.__bbBiscuitsWizardV161 = false;
  window.__bbBiscuitsWizardV162 = false;

  if (window.__bbBiscuitsWizardV163) return;
  window.__bbBiscuitsWizardV163 = true;

  const SEL = {
    wrap: ".biscuits-bundle-steps",
    step: ".biscuits-bundle-step",
    stepSelected: "[data-biscuits-step-selected]",
    card: ".biscuits-bundle-item-card",
    select: "select.biscuits-bundle-item__select",
    checkbox: "input.biscuits-bundle-item-checkbox",
    atcForm: 'form[action*="/cart/add"]',
    atcBtn:
      'form[action*="/cart/add"] button[type="submit"], ' +
      'form[action*="/cart/add"] button[name="add"], ' +
      'form[action*="/cart/add"] input[type="submit"]',
  };

  const IDS = {
    style: "bb-biscuits-v163-style",
    modal: "bb-biscuits-v163-modal",
  };

  const CLS = {
    hiddenOnPage: "bb-v163-hidden-on-page",
    stepHidden: "bb-v163-step-hidden",
    atcNote: "bb-v163-atc-note",
    flash: "bb-v163-flash",
    bodyLock: "bb-v163-body-lock",
    selectedCard: "bb-v163-selected-card",
    selectedBadge: "bb-v163-selected-badge",
    // ✅ NEW: label above size select
    sizeLabel: "bb-v163-size-label",
  };

  const CFG = {
    buildBtnText: "JOIN THE CLUB",
    lockedNoteText: " ",
    titleText: "JOIN THE CLUB",

    // ✅ NEW: label text
    sizeLabelText: "Choose your size",

    editExistingInCart: true,

    // ✅ enforce SINGLE bundle always
    enforceSingleBoxInCart: true,

    // ✅ force SINGLE selection (radio behavior) on these steps (1-based index)
    // If you ever add a step that must allow multiple, remove it here.
    forceSingleSelectSteps: [1, 2, 3, 4],

    // Polling for cart updates after add
    cartPollTries: 12,
    cartPollDelayMs: 250,

    bundleIdKeyHints: [
      "_biscuits_bundle_id",
      "biscuits_bundle_id",
      "biscuits_bundle_uuid",
      "_bundle_id",
      "_bundle_uuid",
      "bundle_id",
      "bundle_uuid",
      "group_id",
      "bundleGroupId",
    ],
  };

  // DOM refs
  let wrap = null;
  let placeholder = null;

  // Modal UI
  let modal = null;
  let overlay = null;
  let panel = null;
  let titleEl = null;
  let btnBack = null;
  let btnNext = null;
  let btnClose = null;

  // State
  let currentIdx = 0;
  let lastSubmitBtn = null;
  let allowNextSubmit = false;
  let isOpen = false;
  let isSubmitting = false;

  // Cached ATC buttons
  let cachedATCButtons = null;
  let cachedATCButtonsAt = 0;

  // Edit state from cart
  let editState = {
    active: false,
    groupId: null,
    lineKeys: [],
    selectionVariantIds: new Set(),
  };

  // Cart snapshot before opening wizard (for revert-on-close)
  let cartBeforeOpen = null;

  // Track last touched checkbox so we keep the one user clicked last
  let lastTouchedCb = null;
  let fixingSingles = false;

  /* ---------------- utils ---------------- */
  /*BORRAR COMENTARIO
  const qsa = (root, sel) => Array.from((root || document).querySelectorAll(sel));
  const qs = (root, sel) => (root || document).querySelector(sel);
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const parseIntSafe = (x) => {
    const n = parseInt((x || "").toString().trim(), 10);
    return Number.isFinite(n) ? n : 0;
  };

  function getCurrentProductHandle() {
    const m = window.location.pathname.match(/\/products\/([^/]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function getSteps() {
    return wrap ? qsa(wrap, SEL.step) : [];
  }

  function getStepNumber(stepEl) {
    // safest: wizard order index
    const steps = getSteps();
    const idx = steps.indexOf(stepEl);
    return idx >= 0 ? idx + 1 : 0;
  }

  function isForceSingleStep(stepEl) {
    const n = getStepNumber(stepEl);
    return !!n && CFG.forceSingleSelectSteps.includes(n);
  }

  function isRequired(stepEl) {
    return stepEl.getAttribute("data-biscuits-required") === "1";
  }

  function minRequired(stepEl) {
    const v = stepEl.getAttribute("data-biscuits-minimum-quantity");
    if (v) return parseIntSafe(v);
    return isRequired(stepEl) ? 1 : 0;
  }

  function selectedCountFromCounter(stepEl) {
    const span = stepEl.querySelector(SEL.stepSelected);
    return parseIntSafe(span?.textContent);
  }

  function cbIsOn(cb) {
    return !!cb && (cb.checked || cb.getAttribute("aria-checked") === "true");
  }

  function selectedCountFromInputs(stepEl) {
    const inputs = qsa(stepEl, SEL.checkbox);
    let count = 0;
    for (const cb of inputs) if (cbIsOn(cb)) count++;
    return count;
  }

  function stepComplete(stepEl) {
    if (!isRequired(stepEl)) return true;
    const min = minRequired(stepEl);
    if (selectedCountFromCounter(stepEl) >= min) return true;
    return selectedCountFromInputs(stepEl) >= min;
  }

  function allRequiredComplete() {
    const steps = getSteps();
    return steps.length > 0 && steps.every(stepComplete);
  }

  function firstIncompleteIndex() {
    const steps = getSteps();
    const idx = steps.findIndex((s) => !stepComplete(s));
    return idx === -1 ? 0 : idx;
  }

  function flash(el) {
    if (!el) return;
    el.classList.add(CLS.flash);
    setTimeout(() => el.classList.remove(CLS.flash), 600);
  }

  /* ---------------- Swiper refresh (minimal) ---------------- */
  
  function refreshSwipersOnce() {
    if (!wrap || !isOpen) return;
    requestAnimationFrame(() => {
      qsa(wrap, ".swiper").forEach((el) => {
        try {
          if (el.swiper && typeof el.swiper.update === "function") {
            el.swiper.update();
            el.swiper.updateSize?.();
            el.swiper.updateSlides?.();
          }
        } catch {}
      });
      window.dispatchEvent(new Event("resize"));
    });
  }

  /* ---------------- Styles ---------------- */
  function injectStyles() {
    [
      "bb-biscuits-v11-style",
      "bb-biscuits-v12-style",
      "bb-biscuits-v13-style",
      "bb-biscuits-v14-style",
      "bb-biscuits-v141-style",
      "bb-biscuits-v15-style",
      "bb-biscuits-v16-style",
      "bb-biscuits-v161-style",
      "bb-biscuits-v162-style",
      "bb-biscuits-v163-style",
    ].forEach((id) => document.getElementById(id)?.remove());

    if (document.getElementById(IDS.style)) return;

    const s = document.createElement("style");
    s.id = IDS.style;
    s.textContent = `
      .${CLS.hiddenOnPage}{
        max-height:0 !important;
        overflow:hidden !important;
        opacity:0 !important;
        pointer-events:none !important;
        margin:0 !important;
        padding:0 !important;
        border:0 !important;
      }
      .${CLS.stepHidden}{ display:none !important; }
      body.${CLS.bodyLock}{ overflow:hidden !important; }

      #${IDS.modal}{ position:fixed; inset:0; z-index:2147483646; display:none; }
      #${IDS.modal}[data-open="true"]{ display:block; }
      #${IDS.modal} .bb-v163-overlay{ position:absolute; inset:0; background:rgba(0,0,0,.55); }

      #${IDS.modal} .bb-v163-panel{
        position:relative;
        width:min(920px, calc(100vw - 24px));
        max-height:calc(100vh - 24px);
        margin:12px auto;
        background:#fff;
        border-radius:14px;
        overflow:auto;
        padding:14px 14px 18px;
        box-shadow:0 16px 50px rgba(0,0,0,.25);
      }

      #${IDS.modal} .bb-v163-bar{
        position:sticky; top:0; z-index:3;
        background:#fff;
        padding:10px 6px 12px;
        border-bottom:1px solid rgba(0,0,0,.10);
        display:flex; align-items:center; justify-content:space-between; gap:10px;
      }
      #${IDS.modal} .bb-v163-title{ font-weight:700; font-size:16px; line-height:1.2; }
      #${IDS.modal} .bb-v163-actions{ display:flex; gap:8px; align-items:center; }

      .bb-v163-btn{
        border:1px solid rgba(0,0,0,.18);
        background:#fff;
        border-radius:10px;
        padding:9px 12px;
        cursor:pointer;
        font: inherit;
      }
      .bb-v163-btn--primary{ background:#000; color:#fff; border-color:#000; }
      .bb-v163-btn:disabled{ opacity:.55; cursor:not-allowed; }
      .bb-v163-build-btn{ display:block; width:100%; margin-top:10px; }

      .${CLS.atcNote}{
        margin-top:8px;
        font-size:13px;
        line-height:1.2;
        opacity:.85;
        display:none;
      }
      .${CLS.flash}{
        outline: 3px solid rgba(0,0,0,.25);
        outline-offset: 6px;
        border-radius: 12px;
      }

      /* Hide prices ONLY inside wizard */
      #${IDS.modal} .biscuits-bundle-price,
      #${IDS.modal} [data-biscuits-current-price],
      #${IDS.modal} .biscuits-bundle-item__price,
      #${IDS.modal} .biscuits-bundle-step__price,
      #${IDS.modal} [data-biscuits-compare-price],
      #${IDS.modal} .biscuits-bundle-price__compare{
        display:none !important;
      }

      /* ✅ NEW: "Choose your size" label (wizard only) */
      #${IDS.modal} .${CLS.sizeLabel}{
        font-size:12px;
        font-weight:600;
        margin: 0 0 6px 0;
        opacity:.85;
      }

      /* Selected highlight */
      .${CLS.selectedCard}{
        outline: 3px solid rgba(0,0,0,.85) !important;
        outline-offset: 3px !important;
        border-radius: 14px !important;
        box-shadow: 0 10px 24px rgba(0,0,0,.12) !important;
      }
      .${CLS.selectedBadge}{
        position:absolute;
        top:10px;
        left:10px;
        z-index:5;
        background:#000;
        color:#fff;
        font-size:12px;
        line-height:1;
        padding:8px 10px;
        border-radius:999px;
        display:flex;
        gap:8px;
        align-items:center;
        max-width: calc(100% - 20px);
      }
      .${CLS.selectedBadge} small{
        opacity:.9;
        font-weight:600;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
      }
    `;
    document.head.appendChild(s);
  }

  /* ---------------- Modal ---------------- */
  function ensureModal() {
    if (modal) return;

    [
      "bb-biscuits-v11-modal",
      "bb-biscuits-v12-modal",
      "bb-biscuits-v13-modal",
      "bb-biscuits-v14-modal",
      "bb-biscuits-v141-modal",
      "bb-biscuits-v15-modal",
      "bb-biscuits-v16-modal",
      "bb-biscuits-v161-modal",
      "bb-biscuits-v162-modal",
      "bb-biscuits-v163-modal",
    ].forEach((id) => document.getElementById(id)?.remove());

    modal = document.createElement("div");
    modal.id = IDS.modal;
    modal.setAttribute("data-open", "false");

    overlay = document.createElement("div");
    overlay.className = "bb-v163-overlay";

    panel = document.createElement("div");
    panel.className = "bb-v163-panel";

    const bar = document.createElement("div");
    bar.className = "bb-v163-bar";

    titleEl = document.createElement("div");
    titleEl.className = "bb-v163-title";
    titleEl.textContent = CFG.titleText;

    const actions = document.createElement("div");
    actions.className = "bb-v163-actions";

    btnBack = document.createElement("button");
    btnBack.type = "button";
    btnBack.className = "bb-v163-btn";
    btnBack.textContent = "Back";

    btnNext = document.createElement("button");
    btnNext.type = "button";
    btnNext.className = "bb-v163-btn bb-v163-btn--primary";
    btnNext.textContent = "Next";

    btnClose = document.createElement("button");
    btnClose.type = "button";
    btnClose.className = "bb-v163-btn";
    btnClose.textContent = "Close";

    actions.appendChild(btnBack);
    actions.appendChild(btnNext);
    actions.appendChild(btnClose);

    bar.appendChild(titleEl);
    bar.appendChild(actions);

    panel.appendChild(bar);

    modal.appendChild(overlay);
    modal.appendChild(panel);
    document.body.appendChild(modal);

    overlay.addEventListener("click", (e) => { e.preventDefault(); e.stopPropagation(); closeWizard(); }, true);
    btnClose.addEventListener("click", (e) => { e.preventDefault(); e.stopPropagation(); closeWizard(); }, true);

    btnBack.addEventListener("click", () => {
      const steps = getSteps();
      if (!steps.length) return;
      currentIdx = Math.max(0, currentIdx - 1);
      renderWizard(true);
    });

    btnNext.addEventListener("click", () => {
      const steps = getSteps();
      if (!steps.length) return;

      if (!stepComplete(steps[currentIdx])) {
        flash(steps[currentIdx]);
        return;
      }

      const isLast = currentIdx >= steps.length - 1;
      if (!isLast) {
        currentIdx += 1;
        renderWizard(true);
      } else {
        addOrUpdateFromWizard();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && isOpen) closeWizard();
    });
  }

  /* ---------------- Mount/unmount ---------------- */
  function ensurePlaceholder() {
    if (!wrap) return;
    if (placeholder && placeholder.isConnected) return;
    placeholder = document.createComment("bb-v163-placeholder");
    wrap.parentNode.insertBefore(placeholder, wrap);
  }

  function mountWrapIntoModal() {
    if (!wrap || !panel) return;
    ensurePlaceholder();
    wrap.classList.remove(CLS.hiddenOnPage);
    panel.appendChild(wrap);
    refreshSwipersOnce();
    requestUpdate(0);
  }

  function unmountWrapBackToPage() {
    if (!wrap || !placeholder) return;
    placeholder.parentNode.insertBefore(wrap, placeholder);
    wrap.classList.add(CLS.hiddenOnPage);
    requestUpdate(0);
  }

  /* ---------------- ATC lock ---------------- */
  function getATCButtonsCached() {
    const now = Date.now();
    if (cachedATCButtons && now - cachedATCButtonsAt < 2000) return cachedATCButtons;

    cachedATCButtons = [];
    qsa(document, SEL.atcForm).forEach((form) => {
      const b =
        form.querySelector('button[type="submit"]') ||
        form.querySelector('button[name="add"]') ||
        form.querySelector('input[type="submit"]');
      if (b) cachedATCButtons.push(b);
    });
    cachedATCButtonsAt = now;
    return cachedATCButtons;
  }

  function ensureATCNote(btn) {
    const wrapEl = btn.closest("form") || btn.parentElement;
    if (!wrapEl) return null;

    let note = wrapEl.querySelector(`.${CLS.atcNote}`);
    if (!note) {
      note = document.createElement("div");
      note.className = CLS.atcNote;
      note.textContent = CFG.lockedNoteText;
      btn.insertAdjacentElement("afterend", note);
    }
    return note;
  }

  function setATCLocked(locked) {
    getATCButtonsCached().forEach((btn) => {
      btn.disabled = locked;
      btn.setAttribute("aria-disabled", locked ? "true" : "false");
      const note = ensureATCNote(btn);
      if (note) note.style.display = locked ? "block" : "none";
    });
  }

  function refreshATCLock() {
    const ok = allRequiredComplete();
    setATCLocked(!ok);

    const steps = getSteps();
    if (isOpen && btnNext && steps[currentIdx]) {
      btnNext.disabled = !stepComplete(steps[currentIdx]);
    }
    return ok;
  }

  /* ---------------- HARD single-select fix ---------------- */
  function enforceSingleSelection(stepEl) {
    if (!stepEl) return;

    // Only enforce where we want radio behavior:
    // - either Biscuits max=1 OR we forced this step
    const max = parseIntSafe(stepEl.getAttribute("data-biscuits-maximum-quantity"));
    const mustBeSingle = (max === 1) || isForceSingleStep(stepEl);
    if (!mustBeSingle) return;

    const checked = qsa(stepEl, SEL.checkbox).filter(cbIsOn);
    if (checked.length <= 1) return;

    // keep last touched if it's in this step and is checked
    let keep = null;
    if (lastTouchedCb && stepEl.contains(lastTouchedCb) && cbIsOn(lastTouchedCb)) {
      keep = lastTouchedCb;
    } else {
      keep = checked[checked.length - 1];
    }

    if (fixingSingles) return;
    fixingSingles = true;
    try {
      for (const cb of checked) {
        if (cb !== keep && cbIsOn(cb)) cb.click();
      }
    } finally {
      setTimeout(() => { fixingSingles = false; }, 0);
    }
  }

  function enforceSinglesAll() {
    const steps = getSteps();
    for (const s of steps) enforceSingleSelection(s);
  }

  /* ---------------- ✅ NEW: Size labels ---------------- */
  function ensureSizeLabels() {
    if (!wrap) return;

    qsa(wrap, SEL.card).forEach((card) => {
      const sel = card.querySelector(SEL.select);
      if (!sel) return;

      // prevent duplicates
      let lbl = card.querySelector(`.${CLS.sizeLabel}`);
      if (!lbl) {
        lbl = document.createElement("div");
        lbl.className = CLS.sizeLabel;
        sel.insertAdjacentElement("beforebegin", lbl);
      }
      lbl.textContent = CFG.sizeLabelText;
    });
  }

  /* ---------------- Selected UI ---------------- */
  function applySelectedUI() {
    if (!wrap) return;

    const steps = getSteps();
    const stepEl = isOpen ? steps[currentIdx] : null;
    const targets = stepEl ? [stepEl] : steps;

    for (const s of targets) {
      const cards = qsa(s, SEL.card);
      for (const card of cards) {
        const cb = card.querySelector(SEL.checkbox);
        const isOn = cbIsOn(cb);

        card.classList.toggle(CLS.selectedCard, isOn);

        if (isOn) {
          const anchor =
            card.querySelector(".biscuits-bundle-item__container") ||
            card.querySelector(".biscuits-bundle-item__image") ||
            card;

          const cs = window.getComputedStyle(anchor);
          if (cs.position === "static") anchor.style.position = "relative";

          let badge = anchor.querySelector(`.${CLS.selectedBadge}`);
          if (!badge) {
            badge = document.createElement("div");
            badge.className = CLS.selectedBadge;
            badge.innerHTML = `<span>Selected</span><small></small>`;
            anchor.appendChild(badge);
          }

          const sel = card.querySelector(SEL.select);
          const label =
            sel?.selectedOptions?.[0]?.textContent?.trim() ||
            sel?.value?.toString()?.trim() ||
            "";

          const prev = badge.getAttribute("data-bb-size") || "";
          if (label !== prev) {
            badge.setAttribute("data-bb-size", label);
            const small = badge.querySelector("small");
            if (small) small.textContent = label ? `• ${label}` : "";
          }
        } else {
          const badge = card.querySelector(`.${CLS.selectedBadge}`);
          if (badge) badge.remove();
        }
      }
    }
  }

  /* ---------------- Debounced update ---------------- */
  let updateQueued = false;
  let updateTimer = null;

  function requestUpdate(delay = 0) {
    if (updateTimer) clearTimeout(updateTimer);
    updateTimer = setTimeout(() => {
      if (updateQueued) return;
      updateQueued = true;
      requestAnimationFrame(() => {
        updateQueued = false;

        // ✅ enforce single selection before anything else
        enforceSinglesAll();

        refreshATCLock();

        // ✅ NEW
        ensureSizeLabels();

        applySelectedUI();
      });
    }, delay);
  }

  /* ---------------- Auto-select single-card steps ---------------- */
  function autoSelectSingleCardIfNeeded(stepEl) {
    if (!stepEl) return;

    // If forced single step, we still allow auto-select if only one card exists
    const max = parseIntSafe(stepEl.getAttribute("data-biscuits-maximum-quantity"));
    const mustBeSingle = (max === 1) || isForceSingleStep(stepEl);

    if (!mustBeSingle) return;
    if (stepComplete(stepEl)) return;

    const cards = qsa(stepEl, SEL.card).filter(
      (c) => c.getAttribute("data-biscuits-available") !== "false"
    );
    if (cards.length !== 1) return;

    const card = cards[0];
    const sel = card.querySelector(SEL.select);
    const cb = card.querySelector(SEL.checkbox);

    if (sel) {
      const firstEnabled = Array.from(sel.options).find((o) => !o.disabled);
      if (firstEnabled && sel.value !== firstEnabled.value) {
        sel.value = firstEnabled.value;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    if (cb && !cbIsOn(cb)) {
      lastTouchedCb = cb;
      cb.click();
    }
  }

  /* ---------------- Wizard render ---------------- */
  function renderWizard(scrollTop = false) {
    const steps = getSteps();
    if (!steps.length) return;

    steps.forEach((s, i) => {
      if (i === currentIdx) s.classList.remove(CLS.stepHidden);
      else s.classList.add(CLS.stepHidden);
    });

    const isLast = currentIdx >= steps.length - 1;

    titleEl.textContent = editState.active
      ? `Editing box • Step ${currentIdx + 1} of ${steps.length}`
      : `Step ${currentIdx + 1} of ${steps.length}`;

    btnBack.disabled = currentIdx === 0;
    btnNext.textContent = isLast ? (editState.active ? "Update cart" : "Add to cart") : "Next";
    btnNext.disabled = !stepComplete(steps[currentIdx]);

    if (scrollTop) panel.scrollTop = 0;

    autoSelectSingleCardIfNeeded(steps[currentIdx]);
    enforceSingleSelection(steps[currentIdx]);

    refreshSwipersOnce();
    requestUpdate(0);
    requestUpdate(160);
  }

  /* ---------------- Open/close ---------------- */
  async function openWizard(submitBtn) {
    if (!wrap) return;

    ensureModal();
    lastSubmitBtn = submitBtn || lastSubmitBtn;

    isSubmitting = false;
    cartBeforeOpen = null;

    // snapshot cart for revert-on-close
    try { cartBeforeOpen = await fetchCart(); } catch {}

    modal.setAttribute("data-open", "true");
    document.body.classList.add(CLS.bodyLock);
    isOpen = true;

    mountWrapIntoModal();

    currentIdx = 0;
    renderWizard(true);

    if (CFG.editExistingInCart) {
      maybeEnterEditModeAndPrefill()
        .catch((err) => console.warn("[bb v16.3] edit mode failed:", err))
        .finally(() => {
          currentIdx = firstIncompleteIndex();
          renderWizard(true);
        });
    } else {
      currentIdx = firstIncompleteIndex();
      renderWizard(true);
    }
  }

  function closeWizard() {
    if (!modal) return;

    modal.setAttribute("data-open", "false");
    document.body.classList.remove(CLS.bodyLock);
    isOpen = false;

    getSteps().forEach((s) => s.classList.remove(CLS.stepHidden));
    unmountWrapBackToPage();
    requestUpdate(0);

    // ✅ if user closed without submitting, revert accidental cart changes
    if (!isSubmitting && CFG.enforceSingleBoxInCart) {
      (async () => {
        try {
          const after = await fetchCart();
          await enforceSingleBoxNow(after, cartBeforeOpen, "keepOld"); // revert accidental add
        } catch (e) {
          console.warn("[bb v16.3] revert on close failed:", e);
        }
      })();
    }
  }

  /* ---------------- Intercept ATC ---------------- */
  function interceptATC() {
    if (document.documentElement.dataset.bbV163Intercept === "1") return;
    document.documentElement.dataset.bbV163Intercept = "1";

    document.addEventListener(
      "click",
      (e) => {
        const btn = e.target.closest(SEL.atcBtn);
        if (btn) lastSubmitBtn = btn;
      },
      true
    );

    document.addEventListener(
      "submit",
      (e) => {
        const form = e.target;
        if (!form || !form.matches(SEL.atcForm)) return;

        if (allowNextSubmit) {
          allowNextSubmit = false;
          return;
        }

        if (!wrap) return;
        if (allRequiredComplete()) return;

        e.preventDefault();
        e.stopPropagation();

        const btn =
          form.querySelector('button[type="submit"], input[type="submit"]') ||
          lastSubmitBtn;

        openWizard(btn || undefined);
      },
      true
    );
  }

  /* ---------------- Build button ---------------- */
  function addBuildButton() {
    qsa(document, SEL.atcForm).forEach((form) => {
      if (form.querySelector('[data-bb-build-btn="v163"]')) return;

      const atcBtn =
        form.querySelector('button[type="submit"]') ||
        form.querySelector('button[name="add"]') ||
        form.querySelector('input[type="submit"]');

      if (!atcBtn) return;

      const build = document.createElement("button");
      build.type = "button";
      build.className = "bb-v163-btn bb-v163-build-btn";
      build.textContent = CFG.buildBtnText;
      build.setAttribute("data-bb-build-btn", "v163");

      atcBtn.insertAdjacentElement("afterend", build);

      build.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        lastSubmitBtn = atcBtn;
        openWizard(atcBtn);
      }, true);
    });
  }

  /* ---------------- Selection UX ---------------- */
  function bindSelectionUX() {
    if (!wrap || wrap.dataset.bbV163Bound === "1") return;
    wrap.dataset.bbV163Bound = "1";

    // click card -> open select (wizard only)
    wrap.addEventListener("click", (e) => {
      if (!isOpen) return;

      const card = e.target.closest(SEL.card);
      if (!card) return;

      const cb = card.querySelector(SEL.checkbox);
      if (cb) lastTouchedCb = cb;

      const stepEl = card.closest(SEL.step);
      if (stepEl) enforceSingleSelection(stepEl);

      const sel = card.querySelector(SEL.select);
      if (!sel) return;

      try { sel.showPicker?.(); } catch {}
      sel.focus();
      sel.click();
    }, true);

    // change size -> select checkbox
    wrap.addEventListener("change", (e) => {
      const t = e.target;
      if (!t || !t.matches(SEL.select)) return;

      const card = t.closest(SEL.card);
      const stepEl = t.closest(SEL.step);
      if (!card || !stepEl) return;

      const cb = card.querySelector(SEL.checkbox);
      if (!cb) return;

      lastTouchedCb = cb;

      // ✅ force radio behavior
      enforceSingleSelection(stepEl);

      if (!cbIsOn(cb)) cb.click();

      // enforce again (Biscuits sometimes toggles 2 on same tick)
      enforceSingleSelection(stepEl);

      requestUpdate(0);
      requestUpdate(160);
    }, true);

    // checkbox clicks
    wrap.addEventListener("click", (e) => {
      const cb = e.target.closest(SEL.checkbox);
      if (!cb) return;

      lastTouchedCb = cb;

      const stepEl = cb.closest(SEL.step);
      if (stepEl) enforceSingleSelection(stepEl);

      requestUpdate(0);
      requestUpdate(160);
    }, true);
  }

  /* ---------------- Cart helpers (EDIT MODE + SINGLE BOX) ---------------- */
  async function fetchCart() {
    const res = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });
    if (!res.ok) throw new Error("Failed to fetch cart.js");
    return res.json();
  }

  function extractGroupIdFromItem(item) {
    const props = item?.properties || {};
    const keys = Object.keys(props);

    for (const k of CFG.bundleIdKeyHints) {
      if (k in props && props[k]) return String(props[k]);
    }

    for (const k of keys) {
      const lk = k.toLowerCase();
      if (lk.includes("biscuits") && (lk.includes("bundle") || lk.includes("group"))) {
        const v = props[k];
        if (v) return String(v);
      }
    }

    return null;
  }

  function getBoxGroupsFromCart(cart) {
    const handle = getCurrentProductHandle();
    const items = Array.isArray(cart?.items) ? cart.items : [];
    if (!handle || !items.length) return { handle, items, baseItems: [], groups: [] };

    const baseItems = items.filter((it) => it.handle === handle);
    if (!baseItems.length) return { handle, items, baseItems: [], groups: [] };

    const groups = baseItems.map((base) => {
      const gid = extractGroupIdFromItem(base);

      let groupItems = [];
      if (gid) {
        groupItems = items.filter((it) => extractGroupIdFromItem(it) === gid);
      } else {
        groupItems = [base];
      }

      const lineKeys = groupItems.map((it) => it.key).filter(Boolean);

      const selectionVariantIds = new Set(
        groupItems
          .map((it) => it.variant_id)
          .filter((vid) => vid && vid !== base.variant_id)
      );

      return { base, groupId: gid, groupItems, lineKeys, selectionVariantIds };
    });

    return { handle, items, baseItems, groups };
  }

  function buildEditStateFromCart(cart) {
    const { groups } = getBoxGroupsFromCart(cart);
    if (!groups.length) {
      return { active: false, groupId: null, lineKeys: [], selectionVariantIds: new Set() };
    }

    const keep = groups[groups.length - 1];
    return {
      active: true,
      groupId: keep.groupId,
      lineKeys: keep.lineKeys,
      selectionVariantIds: keep.selectionVariantIds,
    };
  }

  function prefillWizardFromEditState() {
    if (!wrap || !editState.active) return;

    const remaining = new Set(editState.selectionVariantIds);
    if (!remaining.size) return;

    const steps = getSteps();
    for (const stepEl of steps) {
      const selects = qsa(stepEl, SEL.select);

      for (const sel of selects) {
        for (const vid of Array.from(remaining)) {
          const opt = sel.querySelector(`option[value="${CSS.escape(String(vid))}"]`);
          if (opt && !opt.disabled) {
            sel.value = String(vid);
            sel.dispatchEvent(new Event("change", { bubbles: true }));
            remaining.delete(vid);
            break;
          }
        }
      }

      autoSelectSingleCardIfNeeded(stepEl);
      enforceSingleSelection(stepEl);
    }

    requestUpdate(0);
    requestUpdate(160);
  }

  async function maybeEnterEditModeAndPrefill() {
    editState = { active: false, groupId: null, lineKeys: [], selectionVariantIds: new Set() };

    const cart = await fetchCart();
    const st = buildEditStateFromCart(cart);
    if (!st.active) return;

    editState = st;
    prefillWizardFromEditState();
  }

  async function cartChangeByKey(key, quantity) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!res.ok) throw new Error("cart/change.js failed");
    return res.json();
  }

  function cartSignature(cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    return items.map((it) => `${it.key}:${it.quantity}`).join("|");
  }

  async function waitForCartToChange(preCart) {
    const preSig = preCart ? cartSignature(preCart) : "";
    for (let i = 0; i < CFG.cartPollTries; i++) {
      await sleep(CFG.cartPollDelayMs);
      try {
        const cur = await fetchCart();
        if (!preCart) return cur;
        if (cartSignature(cur) !== preSig) return cur;
      } catch {}
    }
    try { return await fetchCart(); } catch { return preCart; }
  }

  // ✅ MODE:
  // - "keepNew": keep the newest group (used after Add/Update)
  // - "keepOld": keep the pre-existing group (used on Close w/o submit)
  async function enforceSingleBoxNow(cartAfter, cartBefore, mode = "keepNew") {
    if (!CFG.enforceSingleBoxInCart) return;

    const cart = cartAfter || (await fetchCart());
    const { groups } = getBoxGroupsFromCart(cart);
    if (groups.length <= 1) {
      // also clamp qty on kept group if any
      if (groups.length === 1) {
        for (const it of groups[0].groupItems) {
          if (it?.key && (it.quantity || 1) !== 1) {
            try { await cartChangeByKey(it.key, 1); } catch {}
          }
        }
      }
      return;
    }

    const preKeys = new Set((cartBefore?.items || []).map((it) => it.key).filter(Boolean));

    let keepIdx = groups.length - 1; // fallback

    if (preKeys.size) {
      if (mode === "keepOld") {
        // keep the group with the highest overlap with preKeys (base key overlap is strongest)
        let bestScore = -1;
        groups.forEach((g, idx) => {
          const keys = Array.isArray(g.lineKeys) ? g.lineKeys : [];
          let overlap = 0;
          for (const k of keys) if (k && preKeys.has(k)) overlap++;
          const baseKey = g.base?.key;
          if (baseKey && preKeys.has(baseKey)) overlap += 1000;
          if (overlap > bestScore) {
            bestScore = overlap;
            keepIdx = idx;
          }
        });
      } else {
        // keepNew: prefer group with NEW base key (strong signal)
        let bestScore = -1;
        groups.forEach((g, idx) => {
          const keys = Array.isArray(g.lineKeys) ? g.lineKeys : [];
          let newCount = 0;
          for (const k of keys) if (k && !preKeys.has(k)) newCount++;
          const baseKey = g.base?.key;
          const baseIsNew = !!(baseKey && !preKeys.has(baseKey));
          const score = newCount + (baseIsNew ? 1000 : 0);
          if (score > bestScore) {
            bestScore = score;
            keepIdx = idx;
          }
        });
      }
    } else {
      // If there was no bundle before:
      // - keepOld should remove all (leave zero) but safest is keep last? No — user closed, so remove all.
      if (mode === "keepOld") {
        const allKeys = Array.from(new Set(groups.flatMap((g) => g.lineKeys || []))).filter(Boolean);
        for (const key of allKeys) {
          try { await cartChangeByKey(key, 0); } catch {}
        }
        return;
      }
    }

    // Remove all other groups
    const keysToRemove = [];
    groups.forEach((g, idx) => {
      if (idx === keepIdx) return;
      keysToRemove.push(...(g.lineKeys || []));
    });

    for (const key of Array.from(new Set(keysToRemove)).filter(Boolean)) {
      try { await cartChangeByKey(key, 0); } catch (e) { console.warn("[bb v16.3] remove dup key failed", key, e); }
    }

    // Clamp qty=1 on kept group (prevents “2 bundles” via qty increments)
    const kept = groups[keepIdx];
    if (kept?.groupItems?.length) {
      for (const it of kept.groupItems) {
        if (it?.key && (it.quantity || 1) !== 1) {
          try { await cartChangeByKey(it.key, 1); } catch {}
        }
      }
    }

    // Theme refresh signals (best effort)
    try {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated"));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:updated"));
    } catch {}
  }

  /* ---------------- Submit (Add/Update) ---------------- */
  function safeRequestSubmit(form) {
    if (!form) return false;
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit();
      return true;
    }
    const tmp = document.createElement("button");
    tmp.type = "submit";
    tmp.style.display = "none";
    form.appendChild(tmp);
    tmp.click();
    tmp.remove();
    return true;
  }

  function findPrimaryATCFormAndButton() {
    const btn = lastSubmitBtn || qs(document, SEL.atcBtn);
    const form = btn?.form || qs(document, SEL.atcForm);
    return { form, btn };
  }

  function triggerAddToCartNow() {
    const { form, btn } = findPrimaryATCFormAndButton();

    if (btn) {
      const wasDisabled = btn.disabled;
      btn.disabled = false;
      btn.removeAttribute("disabled");

      allowNextSubmit = true;
      btn.click();

      setTimeout(() => {
        if (wasDisabled && !allRequiredComplete()) {
          btn.disabled = true;
          btn.setAttribute("disabled", "");
        }
      }, 250);

      return true;
    }

    allowNextSubmit = true;
    return safeRequestSubmit(form);
  }

  async function addOrUpdateFromWizard() {
    if (!allRequiredComplete()) {
      flash(getSteps()[currentIdx]);
      return;
    }

    // Final safety: prevent multi selection before add
    enforceSinglesAll();

    btnNext.disabled = true;
    btnBack.disabled = true;
    btnClose.disabled = true;
    btnNext.textContent = editState.active ? "Updating..." : "Adding...";

    getSteps().forEach((s) => s.classList.remove(CLS.stepHidden));
    setATCLocked(false);

    isSubmitting = true;

    // Snapshot cart BEFORE add/update
    let cartBefore = null;
    try { cartBefore = await fetchCart(); } catch {}

    closeWizard();

    setTimeout(async () => {
      const ok = triggerAddToCartNow();
      if (ok && CFG.enforceSingleBoxInCart) {
        try {
          const cartAfter = await waitForCartToChange(cartBefore);
          await enforceSingleBoxNow(cartAfter, cartBefore, "keepNew"); // keep updated one

          // extra pass (some themes add twice)
          await sleep(450);
          const cartAfter2 = await fetchCart();
          await enforceSingleBoxNow(cartAfter2, cartBefore, "keepNew");
        } catch (e) {
          console.warn("[bb v16.3] enforce single box failed:", e);
        } finally {
          isSubmitting = false;
        }
      } else {
        isSubmitting = false;
      }
    }, 160);
  }

  /* ---------------- Observers (fast) ---------------- */
  let wrapObserver = null;
  function observeWrap() {
    if (!wrap || wrapObserver) return;

    let last = 0;
    wrapObserver = new MutationObserver(() => {
      const now = Date.now();
      if (now - last < 90) return;
      last = now;

      // ✅ if Biscuits toggles 2 selected, snap back immediately
      enforceSinglesAll();

      requestUpdate(0);
      requestUpdate(160);
    });

    wrapObserver.observe(wrap, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["aria-checked", "checked", "class", "value", "aria-selected"],
    });
  }

  /* ---------------- init ---------------- */
  function initWrap() {
    if (!wrap) return;
    if (wrap.getAttribute("data-bb-v163-init") === "1") return;
    wrap.setAttribute("data-bb-v163-init", "1");

    wrap.classList.add(CLS.hiddenOnPage);

    addBuildButton();
    interceptATC();
    bindSelectionUX();
    observeWrap();

    requestUpdate(0);

    // one-time cart cleanup (optional but helps if cart already has duplicates)
    if (CFG.enforceSingleBoxInCart) {
      (async () => {
        try {
          const c = await fetchCart();
          await enforceSingleBoxNow(c, null, "keepNew");
        } catch {}
      })();
    }
  }

  function init() {
    injectStyles();
    ensureModal();

    wrap = qs(document, SEL.wrap);
    if (wrap) initWrap();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Light re-init if theme replaces the bundle
  let docObsLast = 0;
  const docObs = new MutationObserver(() => {
    const now = Date.now();
    if (now - docObsLast < 400) return;
    docObsLast = now;

    const found = qs(document, SEL.wrap);
    if (found && found !== wrap) {
      wrapObserver?.disconnect?.();
      wrapObserver = null;
      wrap = found;
      initWrap();
    }
  });
  docObs.observe(document.documentElement, { childList: true, subtree: true });

  /* ---------------- Intercept ATC (must be defined before initWrap uses it) ---------------- */
  function interceptATC() {
    if (document.documentElement.dataset.bbV163Intercept === "1") return;
    document.documentElement.dataset.bbV163Intercept = "1";

    document.addEventListener(
      "click",
      (e) => {
        const btn = e.target.closest(SEL.atcBtn);
        if (btn) lastSubmitBtn = btn;
      },
      true
    );

    document.addEventListener(
      "submit",
      (e) => {
        const form = e.target;
        if (!form || !form.matches(SEL.atcForm)) return;

        if (allowNextSubmit) {
          allowNextSubmit = false;
          return;
        }

        if (!wrap) return;
        if (allRequiredComplete()) return;

        e.preventDefault();
        e.stopPropagation();

        const btn =
          form.querySelector('button[type="submit"], input[type="submit"]') ||
          lastSubmitBtn;

        openWizard(btn || undefined);
      },
      true
    );
  }
})();

(function () {

  /* ==============================
     RUN ONLY ON TRANSLATED URLS
     ============================== */

  const path = window.location.pathname.toLowerCase();

  // Matches: /en, /en/, /en-il, /es, /pt, /fr, etc.
  const isTranslated = /^\/[a-z]{2}(\b|\/|-)/.test(path);

  if (!isTranslated) return;

  const SESSION_KEY = "checkout_note_accepted_v1";

  /* ==============================
     CUSTOMIZE YOUR MESSAGE HERE
     ============================== */

  const TITLE = "Important note";

  const MESSAGE = `You will be billed in your local currency, but due to technical limitations with our payment processor, your receipt may display our local currency (NIS).

Example: If you see our prices in USD, you will be billed in USD, but you may see the total value in NIS at checkout.`;

  /* ==============================
     SESSION HANDLING
     ============================== */

  function alreadyAccepted() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function setAccepted() {
    try {
      sessionStorage.setItem(SESSION_KEY, "1");
    } catch (e) {}
  }

  /* ==============================
     STYLES
     ============================== */

  function injectStyles() {
    if (document.getElementById("checkout-note-style")) return;

    const style = document.createElement("style");
    style.id = "checkout-note-style";
    style.innerHTML = `
      .checkout-note-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999999;
        padding: 20px;
      }
      .checkout-note-modal {
        background: #fff;
        border-radius: 12px;
        width: 100%;
        max-width: 480px;
        box-shadow: 0 20px 40px rgba(0,0,0,.2);
        overflow: hidden;
        font-family: inherit;
      }
      .checkout-note-header {
        padding: 18px;
        font-weight: 600;
        border-bottom: 1px solid #eee;
        font-size: 16px;
      }
      .checkout-note-body {
        padding: 18px;
        font-size: 14px;
        line-height: 1.5;
        white-space: pre-line;
      }
      .checkout-note-actions {
        padding: 16px;
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        border-top: 1px solid #eee;
      }
      .checkout-note-btn {
        padding: 10px 16px;
        border-radius: 8px;
        border: 1px solid #ccc;
        background: #fff;
        cursor: pointer;
      }
      .checkout-note-btn.primary {
        background: #111;
        color: #fff;
        border-color: #111;
      }
    `;
    document.head.appendChild(style);
  }

  /* ==============================
     MODAL
     ============================== */

  function showModal() {
    injectStyles();

    return new Promise((resolve) => {

      const overlay = document.createElement("div");
      overlay.className = "checkout-note-overlay";

      const modal = document.createElement("div");
      modal.className = "checkout-note-modal";

      modal.innerHTML = `
        <div class="checkout-note-header">${TITLE}</div>
        <div class="checkout-note-body">${MESSAGE}</div>
        <div class="checkout-note-actions">
          <button class="checkout-note-btn" data-action="cancel">Cancel</button>
          <button class="checkout-note-btn primary" data-action="continue">Continue to checkout</button>
        </div>
      `;

      overlay.appendChild(modal);
      document.body.appendChild(overlay);

      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) {
          overlay.remove();
          resolve(false);
        }
      });

      modal.addEventListener("click", function (e) {
        const btn = e.target.closest("button[data-action]");
        if (!btn) return;

        const action = btn.dataset.action;
        overlay.remove();
        resolve(action === "continue");
      });
    });
  }

  /* ==============================
     DETECT CHECKOUT BUTTONS
     ============================== */

  function isCheckoutTrigger(el) {
    if (!el) return false;

    if (el.matches('button[name="checkout"], input[name="checkout"]')) return true;
    if (el.matches('a[href*="/checkout"], a[href*="/checkouts/"]')) return true;
    if (el.matches('[data-checkout], [data-action="checkout"]')) return true;

    return false;
  }

  /* ==============================
     INTERCEPT CLICK
     ============================== */

  document.addEventListener("click", async function (e) {

    const target = e.target.closest("button, a, input, [data-checkout], [data-action]");
    if (!target) return;
    if (!isCheckoutTrigger(target)) return;

    if (alreadyAccepted()) return;

    e.preventDefault();
    e.stopPropagation();

    const confirmed = await showModal();
    if (!confirmed) return;

    setAccepted();

    // Resume checkout
    if (target.tagName === "A") {
      window.location.href = target.href;
      return;
    }

    const form = target.closest("form");
    if (form) {
      target.click();
    } else {
      window.location.href = "/checkout";
    }

  }, true);

})();

(function () {
if (typeof theme === 'undefined' || !theme.routes) return;

var modalBackdrop, modalEl, closeBtn, activeTrigger;

function buildModal() {
if (modalBackdrop) return;
modalBackdrop = document.createElement('div');
modalBackdrop.className = 'quick-add-modal-backdrop';
closeBtn = document.createElement('button');
closeBtn.type = 'button';
closeBtn.className = 'quick-add-modal-close';
closeBtn.setAttribute('aria-label', 'Close');
closeBtn.textContent = String.fromCharCode(215);
modalEl = document.createElement('div');
modalEl.className = 'quick-add-modal';
document.body.appendChild(modalBackdrop);
document.body.appendChild(modalEl);
document.body.appendChild(closeBtn);
modalBackdrop.addEventListener('click', closeModal);
closeBtn.addEventListener('click', closeModal);
}

function openModal(trigger) {
buildModal();
var card = trigger.closest('product-card');
var template = card && card.querySelector('.quick-add-modal-template');
if (!template) return;
activeTrigger = trigger;
modalEl.innerHTML = '';
modalEl.appendChild(template.content.cloneNode(true));
modalBackdrop.classList.add('is-open');
modalEl.classList.add('is-open');
closeBtn.classList.add('is-open');
document.body.classList.add('quick-add-modal-open');
var submitBtn = modalEl.querySelector('.quick-add-modal-submit');
if (submitBtn) {
updateSubmitState(submitBtn);
}
}
function closeModal() {
  if (!modalBackdrop) return;
  modalBackdrop.classList.remove('is-open');
  modalEl.classList.remove('is-open');
  closeBtn.classList.remove('is-open');
  document.body.classList.remove('quick-add-modal-open');
  activeTrigger = null;
  }

  function updateSubmitState(submitBtn) {
  var selected = modalEl.querySelector('.quick-add-modal-size.is-selected');
  submitBtn.disabled = !selected || !selected.dataset.variantId;
  }

function addToCart(submitBtn) {
  var selected = modalEl.querySelector('.quick-add-modal-size.is-selected');
  if (!selected || !selected.dataset.variantId) return;
  var variantId = selected.dataset.variantId;
  var formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);
  var originalText = submitBtn.textContent;
  submitBtn.disabled = true;
  submitBtn.textContent = 'Adding...';
  fetch(theme.routes.cart_add_url, {
  method: 'POST',
  headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
  body: formData
  }).then(function (response) {
  return response.json();
  }).then(function (data) {
  if (typeof dispatchCustomEvent === 'function') {
  dispatchCustomEvent('cart:item-added', data);
  }
  closeModal();
  }).catch(function () {
  submitBtn.disabled = false;
  submitBtn.textContent = originalText;
  });
  }

document.addEventListener('click', function (e) {
  var trigger = e.target.closest('.quick-add-trigger');
  if (trigger) {
  e.preventDefault();
  openModal(trigger);
  return;
  }
  var sizeBtn = e.target.closest('.quick-add-modal-size');
  if (sizeBtn && modalEl && modalEl.contains(sizeBtn)) {
  if (sizeBtn.disabled) return;
  var siblings = modalEl.querySelectorAll('.quick-add-modal-size');
  for (var i = 0; i < siblings.length; i++) {
  siblings[i].classList.remove('is-selected');
  }
  sizeBtn.classList.add('is-selected');
  var submitBtn2 = modalEl.querySelector('.quick-add-modal-submit');
  if (submitBtn2) {
  updateSubmitState(submitBtn2);
  }
  return;
  }
  var submitClick = e.target.closest('.quick-add-modal-submit');
  if (submitClick && modalEl && modalEl.contains(submitClick)) {
  if (submitClick.disabled) return;
  addToCart(submitClick);
  return;
  }
  });

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape' && modalEl && modalEl.classList.contains('is-open')) {
  closeModal();
  }
  });
  })();
